import { ActiveRecord, sources } from '@mysidewalk/active-record';
import CharacteristicFeatureCollection from './CharacteristicFeatureCollection.js';
import DataReferenceResource from './DataReferenceResource.js';
import DataReferenceCollectionResource from './DataReferenceCollectionResource.js';
/**
 * @memberof geodata
 * @classdesc
 * A GeoJSON feature collection representing data for each of the provided features.
 * Feature geometries are empty/not relevant as this resource only is responsible for
 * delivering exiting characteristics, or making apportionment calculations.
 */
class CharacteristicCollection extends ActiveRecord {
    static fromReferences(featureCollection, dataReferences) {
        const features = featureCollection.features;
        const references = dataReferences.map(props => new DataReferenceResource(props));
        let request = null;
        if (!hasId(featureCollection)) {
            request = CharacteristicFeatureCollection.create({
                type: 'FeatureCollection',
                features,
                references,
            });
        }
        else {
            request = DataReferenceCollectionResource.create({ references })
                .then((referenceCollection) => {
                const promise = CharacteristicCollection.create({
                    type: 'FeatureCollection',
                    feature_collection: featureCollection.id,
                    reference_collection: referenceCollection.id,
                    features: [],
                });
                return promise;
            });
        }
        return request;
    }
}
CharacteristicCollection.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordGeobufSource,
};
function hasId(obj) {
    return typeof obj.id === 'string' && obj.id;
}
export default CharacteristicCollection;
